import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const ChannelApply = () => {
  const [agreed, setAgreed] = useState(false);
  const [channelName, setChannelName] = useState('');
  const [description, setDescription] = useState('');
  const [category, setCategory] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const token = localStorage.getItem('token');

  const categories = [
    'Pi Network Projects',
    'Tech & Apps',
    'Education & Tutorials',
    'Business & Startups',
    'Community & Events',
    'Other (Original Content)',
  ];

  const handleSubmit = async () => {
    if (!agreed) return setError('You must agree to the content policy');
    if (!channelName.trim()) return setError('Channel name is required');
    if (!category) return setError('Please select a category');

    setSubmitting(true);
    try {
      await axios.post('/api/videos/apply-channel/', {
        channel_name: channelName,
        description,
        category,
      }, {
        headers: { Authorization: `Token ${token}` }
      });
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Application failed. Please try again.');
    }
    setSubmitting(false);
  };

  if (submitted) {
    return (
      <div style={{ minHeight: '100vh', background: '#0f0f0f', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
        <div style={{ textAlign: 'center', maxWidth: '500px' }}>
          <div style={{ fontSize: '64px', marginBottom: '20px' }}>✅</div>
          <h2 style={{ color: '#0F6E56', marginBottom: '12px' }}>Application Submitted!</h2>
          <p style={{ color: '#aaa', lineHeight: '1.7' }}>
            Your channel application has been received. Our team will review it within 24-48 hours.
            You will be notified once your channel is approved.
          </p>
          <button onClick={() => navigate('/videos')}
            style={{ marginTop: '24px', background: '#0F6E56', color: '#000', border: 'none', borderRadius: '20px', padding: '12px 32px', fontWeight: '600', cursor: 'pointer' }}>
            Back to Videos
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '100vh', background: '#0f0f0f', color: '#fff', padding: '20px' }}>
      <div style={{ maxWidth: '700px', margin: '0 auto' }}>

        <button onClick={() => navigate('/videos')} style={{ background: 'none', border: 'none', color: '#aaa', cursor: 'pointer', fontSize: '14px', marginBottom: '24px' }}>
          ← Back
        </button>

        <h1 style={{ fontSize: '24px', marginBottom: '8px' }}>🎬 Apply for XpertTube Channel</h1>
        <p style={{ color: '#aaa', marginBottom: '32px' }}>Create your channel and start sharing original content with the Pi community.</p>

        {/* Content Policy */}
        <div style={{ background: '#1a1a2e', border: '1px solid #0F6E56', borderRadius: '12px', padding: '24px', marginBottom: '24px' }}>
          <h3 style={{ color: '#0F6E56', marginTop: 0, marginBottom: '16px' }}>⚠️ Content Policy — Please Read Carefully</h3>
          
          <div style={{ color: '#ddd', lineHeight: '1.8', fontSize: '14px' }}>
            <p style={{ marginBottom: '12px' }}>XpertTube is a <strong style={{ color: '#0F6E56' }}>professional content platform</strong> designed exclusively for:</p>
            
            <ul style={{ paddingLeft: '20px', marginBottom: '16px' }}>
              <li>✅ Pi Network projects, apps & dApps</li>
              <li>✅ Tech tutorials & educational content</li>
              <li>✅ Business presentations & startup pitches</li>
              <li>✅ Community events & Pi ecosystem updates</li>
              <li>✅ Original creative content that adds value</li>
            </ul>

            <p style={{ marginBottom: '12px', color: '#ff6b6b' }}>The following content is <strong>strictly prohibited</strong>:</p>
            
            <ul style={{ paddingLeft: '20px', marginBottom: '16px', color: '#ff9999' }}>
              <li>❌ Funny clips, memes & time-wasting videos</li>
              <li>❌ Copied/reposted content from YouTube or other platforms</li>
              <li>❌ Movies, dramas, songs or copyrighted material</li>
              <li>❌ Political, religious or controversial content</li>
              <li>❌ Misleading or fake information</li>
              <li>❌ Spam or low-quality content</li>
            </ul>

            <div style={{ background: 'rgba(255,0,0,0.1)', border: '1px solid #ff4444', borderRadius: '8px', padding: '12px', marginBottom: '16px' }}>
              <strong style={{ color: '#ff6b6b' }}>⚠️ Warning:</strong>
              <span style={{ color: '#ffaaaa' }}> Violation of these policies may result in immediate channel suspension and permanent account ban without prior notice.</span>
            </div>

            <div style={{ background: 'rgba(15,110,86,0.1)', border: '1px solid #0F6E56', borderRadius: '8px', padding: '12px' }}>
              <strong style={{ color: '#0F6E56' }}>📋 Moderation:</strong>
              <span style={{ color: '#ddd' }}> All videos are reviewed by our admin team before being published. Low quality or policy-violating videos will be rejected.</span>
            </div>
          </div>

          {/* Agree Checkbox */}
          <div style={{ marginTop: '20px', display: 'flex', alignItems: 'flex-start', gap: '12px', cursor: 'pointer' }} onClick={() => setAgreed(!agreed)}>
            <div style={{ width: '20px', height: '20px', border: `2px solid ${agreed ? '#0F6E56' : '#666'}`, borderRadius: '4px', background: agreed ? '#0F6E56' : 'transparent', flexShrink: 0, marginTop: '2px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {agreed && <span style={{ color: '#000', fontSize: '14px', fontWeight: 'bold' }}>✓</span>}
            </div>
            <p style={{ color: '#ddd', margin: 0, fontSize: '14px', lineHeight: '1.6' }}>
              I have read and agree to the XpertTube Content Policy. I understand that uploading prohibited content will result in channel suspension and account ban.
            </p>
          </div>
        </div>

        {/* Channel Details */}
        {agreed && (
          <div style={{ background: '#1a1a1a', border: '1px solid #333', borderRadius: '12px', padding: '24px', marginBottom: '24px' }}>
            <h3 style={{ marginTop: 0, marginBottom: '20px' }}>📝 Channel Details</h3>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', color: '#aaa', fontSize: '13px', marginBottom: '8px' }}>Channel Name *</label>
              <input value={channelName} onChange={e => setChannelName(e.target.value)} placeholder="e.g. PiTech Pakistan"
                style={{ width: '100%', padding: '12px', background: '#0f0f0f', border: '1px solid #333', borderRadius: '8px', color: '#fff', fontSize: '14px', boxSizing: 'border-box' }} />
            </div>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', color: '#aaa', fontSize: '13px', marginBottom: '8px' }}>Category *</label>
              <select value={category} onChange={e => setCategory(e.target.value)}
                style={{ width: '100%', padding: '12px', background: '#0f0f0f', border: '1px solid #333', borderRadius: '8px', color: '#fff', fontSize: '14px', boxSizing: 'border-box' }}>
                <option value="">Select a category</option>
                {categories.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>

            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', color: '#aaa', fontSize: '13px', marginBottom: '8px' }}>Channel Description</label>
              <textarea value={description} onChange={e => setDescription(e.target.value)} placeholder="Tell us what your channel is about and what content you plan to upload..."
                rows={4}
                style={{ width: '100%', padding: '12px', background: '#0f0f0f', border: '1px solid #333', borderRadius: '8px', color: '#fff', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical' }} />
            </div>

            {error && (
              <div style={{ background: 'rgba(255,0,0,0.1)', border: '1px solid #ff4444', color: '#ff6b6b', padding: '12px', borderRadius: '8px', marginBottom: '16px', fontSize: '14px' }}>
                {error}
              </div>
            )}

            <button onClick={handleSubmit} disabled={submitting}
              style={{ width: '100%', padding: '14px', background: submitting ? '#333' : '#0F6E56', color: submitting ? '#666' : '#000', border: 'none', borderRadius: '20px', fontWeight: '700', cursor: submitting ? 'not-allowed' : 'pointer', fontSize: '15px' }}>
              {submitting ? 'Submitting...' : '🚀 Submit Channel Application'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ChannelApply;
